
<div class="container_fieldset">
    <fieldset>
      <legend>Informazioni estratte</legend>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
            [labelInput]="'Materia'" [valueInput]="data.matter.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Tipo Documento'" [valueInput]="data.doc_type.join(', ')"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'ECLI'" [valueInput]="data.ecli.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Numero sentenza'" [valueInput]="data.sentence_number"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Autorità giudiziaria'" [valueInput]="data.AUT_GIUDIZIARIA.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Sezione'" [valueInput]="data.court_section"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Data decisione'" [valueInput]="data.decision_date"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Data pubblicazione'" [valueInput]="data.publish_date"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Esito'" [valueInput]="data.outcome.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'N° ruolo/anno'" [valueInput]="data.case_number"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Giudice'" [valueInput]="data.judge.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Relatore'" [valueInput]="data.rapporteur.join(', ')"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Attore principale'" [valueInput]="data.principal_actor.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Legali attore principale'" [valueInput]="data.legal_principal_actor.join(', ')"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Convenuto'" [valueInput]="data.defendant.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Legali convenuto'" [valueInput]="data.legal_defendant.join(', ')"></div>

      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Sentenza'" [valueInput]="data.opposed_judgement.join(', ')"></div>
      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Corte avversa'" [valueInput]="data.opposed_court.join(', ')"></div>

      <div *ngIf="data.IMPORTO_ECONOMICO && data.IMPORTO_ECONOMICO.length > 0" labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'textarea'"
          [labelInput]="'Importo economico'" [valueInput]="data.IMPORTO_ECONOMICO.join(', ')"></div>

    </fieldset>

</div>
